import * as React from "react"
import { formatPercentage } from "@ui-seeker/utils/"

import { NotAllowedBlock } from "@components"
import { adminScrapingDataReviewPercentageData } from "../../../@signals"


export default function giftsImagesColumn() {
	return {
		name: "giftImages",
		label: `Gifts Images (${formatPercentage(adminScrapingDataReviewPercentageData.value["percentageGiftImages"], { decimals: 2 })})`,
		options: {
			display: false,
			filter: false,
			setCellHeaderProps: () => ({
                sx: {
                    textAlign: "center",
                    minWidth: 80,
                    borderRight: "1px solid",
                    borderColor: "divider"
                }
            }),
			setCellProps: () => ({
                sx: {
                    textAlign: "center",
                    borderRight: "1px solid",
                    borderColor: "divider"
                }
            }),
			customBodyRowRender: value => {
				return value?.length ? "1" : <NotAllowedBlock />
			}
		}
	}
}